<mat-dialog-content>
  <div class="d-flex flex-row align-items-center justify-content-start">
    <img
      class="logo align-self-start"
      src="../../../../../assets/icons/icono.png"
      onerror="this.src = 'assets/img/cantfindimage.jpg'"
    />
    <div>
      <h2 mat-dialog-tittle>{{ 'Warehouse Transfers' | translate }}</h2>
    </div>
  </div>

  <div class="selected-data">
    <span class="caption">{{ 'Transfers' | translate }}</span>
  </div>

  <div class="custom-container">
    <form
      [formGroup]="transferForm"
      class="d-flex flex-row justify-content-between align-items-center flex-column flex-lg-row"
    >
      <div class="custom-items-container transfer-item">
        <mat-form-field class="custom-items-container">
          <mat-label>{{ 'Article' | translate }}</mat-label>
          <input
            id="input-top"
            type="text"
            matInput
            [matAutocomplete]="autoArticle"
            formControlName="article"
          />
          <mat-autocomplete
            #autoArticle="matAutocomplete"
            [displayWith]="displayFnArticle"
          >
            @for (article of articleList; track article) {
              <mat-option class="multiline-mat-option" [value]="article">
                <strong>{{ article.codigo }}</strong> -
                {{ article.descripcion }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        @if (transferForm.get('article')?.value?.id_articulo; as articleId) {
          <v-one-inventory-article-warning
            [articleId]="articleId"
            [articleCode]="transferForm.get('article')?.value?.codigo ?? ''"
          />
        }
      </div>
      <div class="custom-items-container">
        <mat-form-field class="custom-items-container">
          <mat-label>{{ 'Quantity' | translate }}</mat-label>
          <input
            type="number"
            matInput
            formControlName="value"
            autocomplete="off"
          />
        </mat-form-field>
      </div>
      <div class="custom-items-container transfer-item">
        <mat-form-field class="custom-items-container">
          <mat-label>{{ 'Transfer Of' | translate }}</mat-label>
          <input
            id="input-top"
            type="text"
            matInput
            [matAutocomplete]="autoTransferOf"
            formControlName="transferOf"
          />
          <mat-autocomplete
            #autoTransferOf="matAutocomplete"
            [displayWith]="displayFnWarehouse"
          >
            @for (
              warehouse of filteredOptionsTransferOf | async;
              track warehouse
            ) {
              <mat-option class="multiline-mat-option" [value]="warehouse">
                {{ warehouse.nombre }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="trasnfer-icon">
        <mat-icon> 360</mat-icon>
      </div>
      <div class="custom-items-container transfer-item">
        <mat-form-field class="custom-items-container">
          <mat-label>{{ 'Transfer To' | translate }}</mat-label>
          <input
            id="input-top"
            type="text"
            matInput
            [matAutocomplete]="autoTransferTo"
            formControlName="transferTo"
          />
          <mat-autocomplete
            #autoTransferTo="matAutocomplete"
            [displayWith]="displayFnWarehouse"
          >
            @for (
              warehouse of filteredOptionsTransferTo | async;
              track warehouse
            ) {
              <mat-option class="multiline-mat-option" [value]="warehouse">
                {{ warehouse.nombre }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </form>
  </div>

  <div class="selected-data">
    <span class="caption">{{ 'Date' | translate }}</span>
  </div>
  <div
    class="inputs-container d-flex flex-row justify-content-evenly align-items-center flex-column flex-lg-row"
  >
    <div class="date-container">
      <mat-form-field appearance="fill">
        <mat-label>{{ 'Date' | translate }}</mat-label>
        <input
          class="date-input"
          matInput
          [matDatepicker]="picker"
          [formControl]="dateForm"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="custom-items-container transfer-button">
      <button
        class="register-custom-button"
        mat-raised-button
        (click)="register()"
      >
        {{ 'Register' | translate }}
      </button>
    </div>
    <div class="custom-items-container transfer-button">
      <button mat-raised-button mat-dialog-close>
        {{ 'Close' | translate }}
      </button>
    </div>
  </div>
</mat-dialog-content>
